'use strict';

var scrollAnimate = require('base/components/scrollAnimate');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for email sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    $('.email-signup-message').append('<div class="email-signup-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.email-signup-alert').remove();
        button.removeAttr('disabled');
    }, 3000);
}

module.exports = function () {
    $('.back-to-top').click(function () {
        scrollAnimate();
    });

    $('.js-subscribe-sms').on('click', function(e){
        e.preventDefault();
        $('.sms-signup-alert').remove();
        $('.js-subscribe-sms').removeAttr('disabled');

        var smsFormInput = $('.js-sms-form-input');
        if(smsFormInput.val()){
            $('.sms-signup-message').append('<div class="sms-signup-alert text-center">SMS signup successful!</div>');
        }

        setTimeout(function () {
            $('.sms-signup-alert').remove();
            $('.js-subscribe-sms').removeAttr('disabled');
        }, 3000);
    });

    $('.js-subscribe-email').on('click', function (e) {
        e.preventDefault();
        const $button = $(this);
        const url = $button.data('href');
        const emailId = $button.closest('form').find('.js-hp-email-sign-up').val();
        $.spinner().start();
        $(this).attr('disabled', true);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                emailId: emailId
            },
            success: function (data) {
                displayMessage(data, $button);
            },
            error: function (err) {
                displayMessage(err, $button);
            }
        });
    });
};
